export default __webpack_public_path__ + "recruteur.ab43494.png";